import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapState } from 'vuex';

const defaultEl = {
  id: null,
  shift_id: '',
  type: 'qualification',
  qualification_id: '',
  job_id: '',
  user_id: ''
};

export default {
  name: 'ShiftRequirementEdit',
  data () {
    return {
      editEl: defaultEl,
      shift: null,
      isLoading: false
    }
  },
  validations: {
    editEl: {
      shift_id: { required },
      type: { required },
      qualification_id: { },
      job_id: { },
      user_id: { }
    }
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['config']),
    typeOptions () {
      return [
        { value: 'qualification', text: this.$t('shift.requirements.type.options.qualification') },
        { value: 'job', text: this.$t('shift.requirements.type.options.job') },
        { value: 'user', text: this.$t('shift.requirements.type.options.user') }
      ];
    },
    qualificationOptions () {
      return this.$store.getters.getConfigOptions('qualifications', this.$i18n.locale, null, null, false, false, false, ['type_id']);
    },
    jobOptions () {
      const options = this.$store.getters.getConfigOptions('company_jobs', this.$i18n.locale, null, null, false, false, false, ['job_positions']).filter(
        el => {
          const positions = Object.values(el.job_positions);
          for (const pos of positions) {
            if (this.shift.department_id == parseInt(pos.department_id)) {
              if (this.shift.division_id) {
                if (this.shift.division_id == parseInt(pos.division_id)) {
                  return true;
                }
                continue;
              }
              return true;
            }
          }
          return false;
        }
      );

      return this.BasicHelper.sortArrayByKeyValue(options, 'sortText');
    },
    userOptions () {
      let path = 'employees/find-departments-divisions?department_ids[]=' + this.shift.department_id;

      if (this.shift.division_id) {
        path += '&divion_ids[]=' + this.shift.division_id;
      }

      const users = [];
      this.isLoading = true;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          for (const ele of response.data) {
            users.push({ value: parseInt(ele.id), text: ele.name + ' ' + ele.surname });
          }
          this.isLoading = false;
        }
      });

      return users;
    },
    baseTransParam () {
      return 'shift.requirements';
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t(`${this.baseTransParam}.actions.edit`);
      }
      return this.$t(`${this.baseTransParam}.actions.new`);
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    show (elData, shift) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }

      this.shift = shift;
      this.editEl.shift_id = shift.id;

      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }

        const path = 'ezuro/shifts/requirements/save';

        this.ApiRequest.request(path + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$store.dispatch('reloadConfig');
            this.$emit('saved', response.data);
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
